/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../plugins/vant-demand-import/installComponents.js"
import VanButton from 'vant/es/button'
import 'vant/es/button/style/less'
import '/data/paas/jhjj-microcredit-mobile-new/codecode/vant-extra/style-override/button.css'
import VanCollapse from 'vant/es/collapse'
import 'vant/es/collapse/style/less'
import VanCollapseItem from 'vant/es/collapse-item'
import 'vant/es/collapse-item/style/less'
import VanPopup from 'vant/es/popup'
import 'vant/es/popup/style/less'
import '/data/paas/jhjj-microcredit-mobile-new/codecode/vant-extra/style-override/popup.css'


import { render, staticRenderFns } from "./DevApp.vue.js?vue&type=template&id=7a6b7893!=!../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./DevApp.vue?vue&type=template&id=7a6b7893"
import script from "./DevApp.vue.ts?vue&type=script&setup=true&lang=ts!=!../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./DevApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./DevApp.vue.ts?vue&type=script&setup=true&lang=ts!=!../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./DevApp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DevApp.vue.css?vue&type=style&index=0&id=7a6b7893&prod&lang=css!=!../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./DevApp.vue?vue&type=style&index=0&id=7a6b7893&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanButton,VanCollapse,VanCollapseItem,VanPopup})
